import axios from "axios";

const axiosHttp = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const getGroup = () => {
  return axiosHttp.get("/feedback/group");
};

const createGroup = (data) => {
  return axiosHttp
    .post("/feedback/group", data)
    .then((res) => {
      const resp = res.data;
      if (res.error) {
        console.log(resp.error);
      } else {
        return resp;
      }
    })
    .catch((err) => {
      return err;
    });
};

export { getGroup, createGroup };
